export { default } from './LazyPrivacyPolicy';
